import styled from 'styled-components';
import { DatePicker } from 'formik-antd';
import { Box, Button } from 'atoms';

const CancelButton = styled(Button)`
	background: transparent;
	border: 1px solid rgba(211, 47, 47, 0.5);
	color: #d32f2f;
	border-radius: 4px;
`;
const FilterButton = styled(Button)`
	background: transparent;
	border: 1px solid #153e60;
	color: #153e60;
	border-radius: 4px;
`;

const DatePickers = styled(DatePicker)`
	width: 100%;
`;

const ActionAddButton = styled(Button)`
	background: transparent;
	color: #1890ff;
	border-radius: 4px;
`;

const FilterAtnButton = styled(Button)`
	background-color: #18405d;
	color: #fff;
	min-height: 37px;
	margin: 0px;
`;

const ErrorMessageBox = styled(Box)`
	color: #ff4d4f;
`;

const AcctionContainer = styled(Box)`
	position: fixed;
	right: 0;
	bottom: 0;
`;

const { StyledSubmitButton } = styled;

export {
	CancelButton,
	DatePickers,
	ActionAddButton,
	ErrorMessageBox,
	StyledSubmitButton,
	FilterButton,
	FilterAtnButton,
	AcctionContainer,
};
